// ── «Своя нейросеть» в настройках ─────────────────────────────────────────────
// Выбор сервиса (подставляет адрес и модель), ключ, модель, проверка связи.
// Используется для ИИ-объяснений, подробных разборов слов, словаря страницы и
// подсказок перевода (см. customAI.js).

import { useState } from 'react';
import { SANS } from './themes';
import { t } from './i18n';
import { AI_PRESETS, getCustomAI, setCustomAI, checkCustomAI } from './customAI';
import { fieldSurface } from './ui/surface';
import { Button } from './ui';

export default function CustomAISettings({ pal: C }) {
  const saved = getCustomAI();
  const [baseUrl, setBaseUrl] = useState(saved.baseUrl);
  const [key, setKey] = useState(saved.key);
  const [model, setModel] = useState(saved.model);
  const [state, setState] = useState(''); // '' | 'checking' | 'ok' | текст ошибки
  const preset = AI_PRESETS.find((p) => p.baseUrl === baseUrl) || null;
  const has = !!saved.baseUrl;

  const input = { width: '100%', height: 40, ...fieldSurface(C), borderRadius: 8, color: C.text,
    padding: '0 12px', fontSize: 14.5, fontFamily: SANS, outline: 'none', boxSizing: 'border-box', minWidth: 0 };
  const label = { fontSize: 13, color: C.mid, margin: '10px 0 4px' };

  const pick = (id) => {
    const p = AI_PRESETS.find((x) => x.id === id);
    if (!p) { setBaseUrl(''); setModel(''); return; }
    setBaseUrl(p.baseUrl); setModel(p.model); setState('');
  };
  const save = async () => {
    if (!baseUrl.trim() || !model.trim()) { setState(t('Укажите адрес и модель')); return; }
    setCustomAI({ baseUrl, key, model, use: true });
    setState('checking');
    try { await checkCustomAI(); setState('ok'); } catch (e) { setState(e.message || t('Не получилось')); }
  };
  const remove = () => { setCustomAI(null); setBaseUrl(''); setKey(''); setModel(''); setState(''); };

  return (
    <div>
      <div style={{ fontSize: 14.5, fontWeight: 500, color: C.text }}>{t('Своя нейросеть')}</div>
      <div style={{ fontSize: 12.5, color: C.faint, lineHeight: 1.45, marginTop: 2 }}>
        {t('Любой сервис с API как у OpenAI: объяснения, разборы слов и словарь страницы пойдут через него. Ключ хранится только на этом устройстве.')}
      </div>
      <div style={label}>{t('Сервис')}</div>
      <select value={preset ? preset.id : baseUrl ? 'other' : ''} onChange={(e) => pick(e.target.value)} style={{ ...input, cursor: 'pointer' }} aria-label={t('Сервис')}>
        <option value="">{t('— выберите —')}</option>
        {AI_PRESETS.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        <option value="other">{t('Другой (свой адрес)')}</option>
      </select>
      <div style={label}>{t('Адрес API')}</div>
      <input value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} placeholder="https://api.example.com/v1" spellCheck={false} autoComplete="off" style={input} aria-label={t('Адрес API')} />
      <div style={label}>{t('Ключ')}{preset?.keyUrl ? <> · <a href={preset.keyUrl} target="_blank" rel="noreferrer" style={{ color: C.blueDark }}>{t('где взять')}</a></> : null}</div>
      <input type="password" value={key} onChange={(e) => setKey(e.target.value)} placeholder={preset && !preset.keyUrl ? t('не нужен') : 'sk-…'} spellCheck={false} autoComplete="off" style={input} aria-label={t('Ключ')} />
      <div style={label}>{t('Модель')}</div>
      <input value={model} onChange={(e) => setModel(e.target.value)} placeholder="gpt-4o-mini" spellCheck={false} autoComplete="off" style={input} aria-label={t('Модель')} />
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
        <Button variant="primary" onClick={save}>{state === 'checking' ? t('Проверяю…') : t('Сохранить и проверить')}</Button>
        {has && <Button onClick={remove}>{t('Удалить')}</Button>}
      </div>
      {state && state !== 'checking' && (
        <div role="status" style={{ marginTop: 8, fontSize: 13, color: state === 'ok' ? C.green : C.danger, lineHeight: 1.45 }}>
          {state === 'ok' ? t('✓ Работает — теперь объяснения и разборы идут через {0}', [model]) : state}
        </div>
      )}
    </div>
  );
}
